import { playHoldMusic, stopRingtone } from '../../../services/audio-manager'

/**
 * Loops hold music for a party placed on hold (manual Hold or call transfer).
 * Mutes the remote Chime audio element while hold music plays.
 *
 * Playback goes through the audio-manager's shared gesture-unlocked element:
 * the held party receives HOLD without any local gesture, and a fresh
 * `new Audio()` there was silently blocked by autoplay policy (the
 * "on-hold music not working" report).
 */
const HOLD_MUSIC_VOLUME = 0.32

export class HoldMusicPlayer {
  private playing = false
  private remoteAudioEl: HTMLAudioElement | null = null
  private savedRemoteVolume = 1

  /** Start hold music and mute remote meeting audio. */
  start(holdMusicUrl: string, remoteAudioEl: HTMLAudioElement | null): void {
    this.stop()
    this.remoteAudioEl = remoteAudioEl
    if (remoteAudioEl) {
      this.savedRemoteVolume = remoteAudioEl.volume
      remoteAudioEl.volume = 0
      remoteAudioEl.muted = true
    }
    this.playing = true
    playHoldMusic(holdMusicUrl, HOLD_MUSIC_VOLUME)
  }

  stop(): void {
    if (this.playing) {
      stopRingtone()
      this.playing = false
    }
    if (this.remoteAudioEl) {
      this.remoteAudioEl.muted = false
      this.remoteAudioEl.volume = this.savedRemoteVolume
      this.remoteAudioEl = null
    }
  }
}
